import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  backToBankLanding: {
    id: "funding-application: Back to bank business landing",
    defaultMessage: "Back to Connect your business bank accounts",
  },
  backToBankConnect: {
    id: "funding-application: Back to bank landing",
    defaultMessage: "Back to Bank connections",
  },
  countrySelectionModalTitle: {
    id: "funding-application: Connect to your bank account",
    defaultMessage: "Connect to your bank account",
  },
  countrySelectionModalHelperText: {
    id: "funding-application: Select country",
    defaultMessage: "Select country",
  },
  selectCountryError: {
    id: "funding-application: select country missing error",
    defaultMessage: "Please select a country",
  },
  loadingBankData: {
    id: "funding-application: loading banking data message",
    defaultMessage: "Loading banking data, please wait",
  },
  uploadMoreFiles: {
    id: "funding-application: upload more files label",
    defaultMessage: "Upload more files",
  },
});
